<template lang="pug">
  v-container.layout(fluid)
    v-layout(column wrap align-center justify-center)
      v-progress-circular(
        :size='80'
        :width='8'
        color='primary'
        indeterminate
      )
      span Connecting to TransactionDesk...
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      code: '',
    };
  },
  async mounted() {
    try {
      const { code } = this.$route.query;
      if (code){
        await this.saveTokenTransactiondesk({code});
      }
    } catch (e) {}

    window.close();
  },
  methods: {
    ...mapActions('transactionDesk', ['saveTokenTransactiondesk']),
  },
};
</script>
